import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

const useDebounce = (value, delay, shouldResetPage = false, onResetPage) => {
  const dispatch = useDispatch();
  const [debouncedValue, setDebouncedValue] = useState(value);
  const prevValueRef = useRef(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);

      const hasActuallyChanged = prevValueRef.current !== value;

      if (shouldResetPage && hasActuallyChanged) {
        // dispatch(setCurrentPage(1));
        onResetPage();
      }

      prevValueRef.current = value;
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, shouldResetPage, dispatch]);

  return debouncedValue;
};

export default useDebounce;
